import React, { useState } from 'react';
import {ExternalLeadType} from "./type/externalLeadType";
import {EnvConfig} from "../../Shared/Constants/environtmentConstants";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import {SaveExternalLeadUnicContactHook} from "./hook/saveExternalLeadUnicContactHook";

const WinahostHelpSection = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState<ExternalLeadType>({
    name: '',
    phone: '',
    email: '',
    address: '',
    type: '',
  });
  const [showForm, setShowForm] = useState(false);

  const items = [
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          fill="none"
          stroke="#1a237e"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
        </svg>
      ),
      title: 'Revisión de documentación',
      description: 'Rellena tus datos para que podamos ayudarte de manera más precisa y rápida.',
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          fill="none"
          stroke="#1a237e"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      ),
      title: 'Contacto y asesoramiento',
      description: 'Uno de nuestros expertos te escribirá para explicarte cómo continuar paso a paso.',
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          fill="none"
          stroke="#1a237e"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      ),
      title: 'Guía hasta finalizar el trámite',
      description: 'No estás solo: te acompañamos hasta que obtengas tu número de registro oficial.',
    },
  ];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const changeLocationData = (key: string, value: any) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  const nextStep = () => {
    console.log('Error: Faltan datos obligatorios');
    if (!formData.name || !formData.phone || !formData.email) {
      alert('Por favor completa todos los campos.');
      return;
    }
    setStep(2)
  };

  const submitForm = () => {

    if (!formData.name || !formData.phone || !formData.email || !formData.address || !formData.type) {
        alert('Por favor completa todos los campos.');
        return;
    }

    SaveExternalLeadUnicContactHook(formData)
        .then((response) => {
          if (response.status === 200) {
            setFormData({ name: '', phone: '', email: '', address: '', type: '' });
            setShowForm(false);
            setStep(1);
          } else {
            alert('Error al enviar el formulario. Intenta nuevamente.');
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          alert('Error al enviar el formulario. Intenta nuevamente.');
        });
  };

  const ctaButtonStyle = {
    backgroundColor: '#1a237e',
    color: 'white',
    padding: '12px 32px',
    borderRadius: '25px',
    textDecoration: 'none',
    fontWeight: '600',
    border: 'none',
    cursor: 'pointer',
    width: '100%',
  };

  const inputStyle = {
    display: 'block',
    width: '100%',
    padding: '10px',
    marginBottom: '15px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    backgroundColor: '#fff',
  };

  return (
    <section style={{ padding: '60px 20px', backgroundColor: '#f0f4f8' }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#1a237e', marginBottom: '12px' }}>
          ¿Cómo te ayudamos con el trámite?
        </h2>
        <p style={{ fontSize: '1rem', color: '#666', marginBottom: '40px' }}>
          Sabemos que el proceso de registro puede ser complicado. Por eso, te ofrecemos un servicio gratuito para ayudarte a obtener tu número de registro oficial.
        </p>

        <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '20px', marginBottom: '30px' }}>
          {items.map((item, idx) => (
            <div
              key={idx}
              style={{
                flex: '1 1 300px',
                border: '1px solid #e0e0e0',
                borderRadius: '12px',
                padding: '30px 20px',
                textAlign: 'center',
                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.03)',
                backgroundColor: '#fff',
              }}
            >
              <div style={{ marginBottom: '16px' }}>{item.icon}</div>
              <h3 style={{ fontSize: '1rem', fontWeight: '600', marginBottom: '10px' }}>{item.title}</h3>
              <p style={{ fontSize: '0.95rem', color: '#444', lineHeight: '1.5' }}>{item.description}</p>
            </div>
          ))}
        </div>

        {!showForm ? (
          <button style={ctaButtonStyle} onClick={() => setShowForm(true)}>
            Empieza el registro
          </button>
        ) : step === 1 ? (
          <div style={{ maxWidth: '500px', margin: '0 auto', textAlign: 'left' }}>
            <h3 style={{ fontSize: '1.2rem', marginBottom: '20px', color: '#1a237e' }}>
              Obtén una estimación de ingresos personalizada:
            </h3>
            <input
              type="text"
              name="name"
              placeholder="Nombre"
              value={formData.name}
              onChange={handleChange}
              style={inputStyle}
            />
            <input
              type="tel"
              name="phone"
              placeholder="Teléfono"
              value={formData.phone}
              onChange={handleChange}
              style={inputStyle}
            />
            <input
              type="email"
              name="email"
              placeholder="Mail"
              value={formData.email}
              onChange={handleChange}
              style={inputStyle}
            />
            <button
              style={ctaButtonStyle}
              onClick={nextStep}
            >
              Siguiente
            </button>
          </div>
        ) : (
          <div style={{ maxWidth: '500px', margin: '0 auto', textAlign: 'left' }}>
            <h3 style={{ fontSize: '1.2rem', marginBottom: '20px', color: '#1a237e' }}>
              Información adicional
            </h3>
            <GooglePlacesAutocomplete
                apiKey={EnvConfig().google_places_api_key}
                apiOptions={{
                  region: 'es'
                }}
                selectProps={{
                  defaultInputValue: formData.address,
                  placeholder: 'Ej: nombre de la calle, 123, Ciudad',
                  onChange: (e: any) => changeLocationData('address', e.label),
                  instanceId: 'react-select-3-live-region',
                  className: 'selectFormValueCustomStyled',
                  classNames: {
                    control: () => {
                      return 'selectInputCustomStyled'
                    },
                    menu: () => {
                      return 'selectMenuCustomStyled';
                    }
                  }
                }}
            />
            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
              style={inputStyle}
            >
              <option value="">Tipo de alquiler</option>
              <option value="tourist">Turístico</option>
              <option value="temporary">Temporal</option>
            </select>
            <button
              style={ctaButtonStyle}
              onClick={submitForm}
            >
              Ayuda gratuita con el trámite
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default WinahostHelpSection;